import React from 'react';

import { useRouter } from 'next/navigation';

import { If } from 'react-if';

import { Box } from '@nerdwallet/currency/components/Box';
import { Link } from '@nerdwallet/currency/components/Link';
import { Text } from '@nerdwallet/currency/components/Text';

import Paths from '@lib/paths';

import { usePlaidFooterInstitutionContext } from '@components/financial-institutions/plaid-sandbox/plaid-footer-institution-context';
import { PlaidStep } from '@components/financial-institutions/plaid-sandbox/plaid-modal-stepper';

import { AccountWarningIcon } from '../../dashboard-icons/dashboard-icons';

import styles from './styles.module.scss';
import { usePlaidModalVisibility } from '@components/financial-institutions/plaid-sandbox/plaid-modal-visibility-context';

const UserActionInstitutions = () => {
  const router = useRouter();

  const { actionRequiredState } = usePlaidFooterInstitutionContext();
  const { setShowPlaidVisibility } = usePlaidModalVisibility();

  const handleSeeDetails = () => {
    // If user only has one institution that needs action, allow the user to fix it from the footer.
    // Otherwise, just navigate to the Accounts page and they can fix it there.
    if (actionRequiredState.numAccountsActionRequired === 1) {
      setShowPlaidVisibility({
        show: true,
        plaidStep: PlaidStep.PLAID_FIX,
        selectedPortal: actionRequiredState.portal,
      });
    } else {
      router.push(Paths.DASHBOARD_NET_WORTH);
    }
  };

  return (
    <div className={styles.container}>
      <AccountWarningIcon />
      <div className={styles.accountsErrorTextContainer}>
        <Box marginLeft={3}>
          <Text bold size="small">
            <If condition={actionRequiredState.numAccountsActionRequired === 1}>
              <>1 account needs your attention.</>
            </If>

            <If condition={actionRequiredState.numAccountsActionRequired > 1}>
              <>
                {actionRequiredState.numAccountsActionRequired} accounts need
                your attention.
              </>
            </If>
          </Text>
        </Box>

        <Box marginLeft={3}>
          <Link size="small" onClick={handleSeeDetails}>
            See details
          </Link>
        </Box>
      </div>
    </div>
  );
};

export default UserActionInstitutions;
